import { render, staticRenderFns } from "./KakaoTemplate.vue?vue&type=template&id=0a28f24a&scoped=true&"
import script from "./KakaoTemplate.vue?vue&type=script&lang=ts&"
export * from "./KakaoTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./KakaoTemplate.vue?vue&type=style&index=0&id=0a28f24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28f24a",
  null
  
)

export default component.exports